import fileUtils from '../../util/fileUtils';

const getHeaders = () => ({
  Accept: 'application/json, text/plain',
  'MERCATELY-AUTH-TOKEN': ENV.MERCATELY_AUTH_TOKEN,
  'RETAILER-KEY': ENV.UNIQUE_KEY,
  'Content-Type': 'application/json'
});

const getFormHeaders = () => ({
  'MERCATELY-AUTH-TOKEN': ENV.MERCATELY_AUTH_TOKEN,
  'RETAILER-KEY': ENV.UNIQUE_KEY,
  Accept: 'application/json, text/plain, */*'
});

const handleResponse = async (response) => {
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || data.error || 'Error en la solicitud');
  }
  return data;
};

const CustomFieldsModelMC = {
  /**
   * Get custom fields with pagination and search
   * @param {Object} params - Query parameters
   * @returns {Promise<Object>} - Response with custom_fields and pagination info
   */
  get: async (params = {}) => {
    const queryParams = new URLSearchParams();

    if (params.page) queryParams.append('page', params.page);
    if (params.textSearch) queryParams.append('q[name_or_label_i_cont]', params.textSearch);
    queryParams.append('q[made_for_eq]', '0'); // 0 = orders

    const endpoint = `${ENV.SHOPS_BASE_URL}/api/v1/retailers/custom_fields?${queryParams.toString()}`;

    const response = await fetch(endpoint, {
      method: 'GET',
      headers: getHeaders()
    });

    return handleResponse(response);
  },

  /**
   * Create a new custom field
   * @param {Object} data - Custom field data
   * @returns {Promise<Object>} - Created custom field
   */
  create: async (data) => {
    const endpoint = `${ENV.SHOPS_BASE_URL}/api/v1/retailers/custom_fields`;
    const formData = fileUtils.objectToFormData({ custom_field: data });

    const response = await fetch(endpoint, {
      method: 'POST',
      headers: getFormHeaders(),
      body: formData
    });

    return handleResponse(response);
  },

  /**
   * Update a custom field
   * @param {number} id - Custom field ID
   * @param {Object} data - Custom field data
   * @returns {Promise<Object>} - Updated custom field
   */
  update: async (id, data) => {
    const endpoint = `${ENV.SHOPS_BASE_URL}/api/v1/retailers/custom_fields/${id}`;
    const formData = fileUtils.objectToFormData({ custom_field: data });

    const response = await fetch(endpoint, {
      method: 'PUT',
      headers: getFormHeaders(),
      body: formData
    });

    return handleResponse(response);
  },

  /**
   * Delete a custom field
   * @param {number} id - Custom field ID
   * @returns {Promise<Object>} - Deleted custom field
   */
  delete: async (id) => {
    const endpoint = `${ENV.SHOPS_BASE_URL}/api/v1/retailers/custom_fields/${id}`;

    const response = await fetch(endpoint, {
      method: 'DELETE',
      headers: getHeaders()
    });

    return handleResponse(response);
  },

  /**
   * Toggle custom field active status
   * @param {number} id - Custom field ID
   * @param {boolean} active - Active status
   * @returns {Promise<Object>} - Updated custom field
   */
  toggleActive: async (id, active) => {
    const endpoint = `${ENV.SHOPS_BASE_URL}/api/v1/retailers/custom_fields/${id}`;
    const formData = fileUtils.objectToFormData({ custom_field: { active } });

    const response = await fetch(endpoint, {
      method: 'PUT',
      headers: getFormHeaders(),
      body: formData
    });

    return handleResponse(response);
  }
};

export default CustomFieldsModelMC;
